import { render, staticRenderFns } from "./newprogram.vue?vue&type=template&id=5db2c1af&scoped=true&"
import script from "./newprogram.vue?vue&type=script&lang=js&"
export * from "./newprogram.vue?vue&type=script&lang=js&"
import style0 from "./newprogram.vue?vue&type=style&index=0&id=5db2c1af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2c1af",
  null
  
)

export default component.exports